module.exports = __webpack_public_path__ + "static/img/shopNameBack.ab4a9271.png";